import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Header, Segment, Input, Button, Container } from "semantic-ui-react";
import { StartUserSurveyDto } from "../../../models/startUserSurveyDto";
import agent from "../../../api/agent";
import { toast } from "react-toastify";

interface Props {
  onNavigateNext: () => void;
  onNavigatePrevious: () => void;
  userSurveyId: number;
}

export default function PostSurveyContactDetails({
  onNavigateNext,
  onNavigatePrevious,
  userSurveyId,
}: Props) {
  const { t } = useTranslation("common");
  const [email, setEmail] = useState<string>("");
  const [validEmail, setValidEmail] = useState<boolean>(true);
  const [phone, setPhone] = useState<string>("");
  const [validPhone, setValidPhone] = useState<boolean>(true);
  const [telegram, setTelegram] = useState<string>("");
  const [validTelegram, setValidTelegram] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);

  const save = () => {
    setSaving(true);
    let dto: StartUserSurveyDto = {
      userSurveyId: userSurveyId,
      email: email,
      phoneNumber: phone,
      telegramUserName: telegram,
    };
    agent.UserSurveys.saveUserSurveyContactDetails(dto)
      .then((result) => {
        onNavigateNext();
      })
      .catch(() => {
        handleError();
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const handleError = () => toast.error(t("Common.OfflineMessage"));

  const validateEmail = (): boolean => {
    if (email === "") return true;
    let regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (regex.test(email)) {
      setValidEmail(true);
      return true;
    } else {
      setValidEmail(false);
      return false;
    }
  };

  const validatePhoneNumber = (): boolean => {
    if (phone === "") return true;
    let regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{2,6}$/im;

    if (regex.test(phone)) {
      setValidPhone(true);
      return true;
    } else {
      setValidPhone(false);
      return false;
    }
  };

  const validateTelegram = (): boolean => {
    if (telegram === "") return true;
    if (telegram.startsWith("@")) {
      setValidTelegram(true);
      return true;
    } else {
      setValidTelegram(false);
      return false;
    }
  };

  return (
    <>
      <Segment inverted color="blue" className="survey-intro-header">
        <Header as="h1">{t("ContactDetails.PageTitle")}</Header>
      </Segment>
      <div className="pre-post-txt">{t("ContactDetails.FurtherDetails")}</div>
      <div className="pre-post-txt"> {t("ContactDetails.Confidential")}</div>
      <div className="pre-post-txt">
        {t("ContactDetails.PreferredContactMethod")}
        <br />
        <br />
        <div>
          <Input
            type="email"
            label={t("ContactDetails.Email")}
            placeholder={t("ContactDetails.Email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        {!validEmail && email != "" && (
          <div id="divEmailError">{t("ContactDetails.EmailValidationMessage")}</div>
        )}
        <br />
        <div>
          <Input
            label={t("ContactDetails.Mobile")}
            placeholder={t("ContactDetails.Mobile")}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>
        {!validPhone && phone != "" && (
          <div id="divPoneError">{t("ContactDetails.MobileValidationMessage")}</div>
        )}
        <br />
        <div>
          <Input
            label={t("ContactDetails.TelegramUsername")}
            placeholder={t("ContactDetails.TelegramUsername")}
            value={telegram}
            onChange={(e) => setTelegram(e.target.value)}
          />
        </div>
        {!validTelegram && telegram != "" && (
          <div id="divTelegramError">{t("ContactDetails.TelegramValidationMessage")}</div>
        )}
      </div>
      <Container className="survey-btns">
        <Segment>
          <Button
            primary
            floated="left"
            onClick={() => {
              onNavigatePrevious();
            }}
          >
            {t("Common.Previous")}
          </Button>

          <Button
            positive
            primary
            floated="right"
            loading={saving}
            disabled={phone === "" && email === "" && telegram === ""}
            onClick={() => {
              const validEmail = validateEmail();
              const validPhone = validatePhoneNumber();
              const validTelegram = validateTelegram();
              if (validEmail && validPhone && validTelegram) save();
            }}
          >
            {t("Common.Submit")}
          </Button>
        </Segment>
      </Container>
    </>
  );
}
